import $ from "jquery";
import "./featured";
import "./filters";

const preloader = $(".resources-list-preloader"),
  filterForm = $("#resources-filter-form"),
  resourcesListWrapper = $(".resources-list-wrapper .resources-list-posts__wrap"),
  resourcesPosts = $(".resources-list-posts"),
  resourcesCheckbox = $(".filter-form__checkbox"),
  resourcesFormSearch = $(".search-resource"),
  clearSearchButton = $(".clear-btn"),
  searchIcon = $(".search-icon"),
  resourcesFormSubmit = $(".resources-form-submit"),
  clearURL = window.location.href.split("?")[0],
  filterReset = $("#filter-reset");

filterReset.hide();

resourcesFormSubmit.click(function (e) {
  e.preventDefault();

  if ($(this).attr("href") !== "#") {
    // Get the URL with the updated filters
    const newUrl = $(this).attr("href");

    // Check if the URL is different from the current URL to avoid redundant updates
    if (newUrl !== window.location.href) {
      // Update the URL without causing a page reload or scroll
      history.pushState(null, "", newUrl);

      resourcesFilterSubmit();
    }
  }
});
function searchParamsUpdate() {
  let blogFilterData = decodeURI(filterForm.serialize()).replace("[]", "");
  let blogFilterDataCleared = blogFilterData.replace(/[[]]/g, "");
  let searchParams = clearURL + "?" + blogFilterDataCleared;
  resourcesFormSubmit.attr("href", searchParams);
}

function updateFilterLabels() {
  $(".filter-form-select").each(function () {
    let selectedTexts = [];

    $(this)
      .find(".filter-form__checkbox:checked")
      .each(function () {
        selectedTexts.push($(this).next("label").text());
      });

    let displayText = selectedTexts.join(", ");
    if (displayText.length > 38) {
      displayText = displayText.substring(0, 38) + "...";
    }

    // Update text or return default
    $(this)
      .find(".filter-form-select__brand")
      .text(displayText || $(this).find(".filter-form-select__brand").data("default"));
  });
}

function clearFilters() {
  blogVars.filtered = false;
  resourcesCheckbox.prop("checked", false);
  filterReset.hide();
  window.location = clearURL;
}

// Init the default text
$(".filter-form-select__brand").each(function () {
  $(this).data("default", $(this).text());
});

function resourcesFilterSubmit() {
  let blogFilterData = filterForm.serialize();
  const featuredIds = JSON.parse($(".resources-list-wrapper-container").attr("data-featured"));
  $.ajax({
    type: "POST",
    url: themeVars.ajaxUrl,
    data: {
      action: "postsLoad",
      data: blogFilterData,
      paged: blogVars.currentPage,
      featured: featuredIds,
    },
    beforeSend: function () {
      $("html, body").animate({ scrollTop: resourcesPosts.offset().top - $("header").height() }, 500);
      preloader.fadeIn();
    },
    success: function (response) {
      let parsedResponse = JSON.parse(response);
      blogVars.posts = parsedResponse.posts;
      blogVars.maxPage = parsedResponse.maxPage;
      blogVars.currentPage = parsedResponse.currentPage;
      blogVars.foundPosts = parsedResponse.foundPosts;
      blogVars.postsSearch = parsedResponse.postsSearch;
      blogVars.filtered = parsedResponse.filtered;
      resourcesListWrapper.fadeOut(function () {
        preloader.fadeOut();
        if (blogVars.filtered || blogVars.postsSearch) {
          filterReset.show();
          resourcesFormSubmit.hide();
          if (resourcesFormSearch.val().length > 0) {
            clearSearchButton.show();
            searchIcon.hide();
          }
        } else {
          filterReset.hide();
          resourcesFormSubmit.show();
        }
        resourcesListWrapper.html(parsedResponse.content);
        resourcesListWrapper.fadeIn(1000);
        updateFilterLabels();
      });
    },
  });
}

filterForm.on("keypress", function (e) {
  let keyPressed = e.keyCode || e.which;
  if (keyPressed === 13) {
    e.preventDefault();
    return false;
  }
});

resourcesCheckbox.on("change", function () {
  searchParamsUpdate();
});

resourcesFormSearch.on("input", function () {
  if (resourcesFormSearch.val().length > 0) {
    clearSearchButton.show();
    searchIcon.hide();
    searchParamsUpdate();
    filterReset.hide();
    resourcesFormSubmit.show();
  } else {
    clearSearchButton.hide();
    searchIcon.show();
  }
});

resourcesFormSearch.on("keydown", function (e) {
  let keyPressed = e.keyCode || e.which;
  if (keyPressed === 13) {
    searchParamsUpdate();
    filterReset.show();
    resourcesFormSubmit.hide();
    resourcesFormSubmit.trigger("click");
  }
});

clearSearchButton.on("click", function () {
  resourcesFormSearch.val("").submit();
  clearSearchButton.hide();
  searchIcon.show();
  searchParamsUpdate();
  filterReset.hide();
  resourcesFormSubmit.show();
});

filterReset.on("click", function () {
  clearFilters();
});

$(document).on("click", ".resources-list-wrapper .page-numbers", function (e) {
  e.preventDefault();
  $("html, body").animate({ scrollTop: resourcesPosts.offset().top - $("header").height() }, "slow");
  const clicked_url = $(this).attr("href");
  const page = clicked_url.match(/\/page\/(\d*)/);
  let clicked_page = page !== null ? page[1] : 1;
  clicked_page = parseInt(clicked_page, 10);
  const featuredIds = JSON.parse($(".resources-list-wrapper-container").attr("data-featured"));

  $.ajax({
    type: "POST",
    url: themeVars.ajaxUrl,
    data: {
      action: "loadmorePostsAjaxHandler",
      query: blogVars.posts,
      page: clicked_page,
      ppp: 9,
      featured: featuredIds,
    },
    beforeSend: function () {
      preloader.fadeIn();
    },
    success: function (response) {
      preloader.fadeOut();
      if (response) {
        response = $(response).hide().fadeIn();
        resourcesListWrapper.html(response);
        blogVars.currentPage = clicked_page;
      }
    },
  });
});

//trigger if URL has get parameter
$(document).ready(function () {
  let urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has("search-resource")) {
    let searchValue = urlParams.get("search-resource");
    $(".search-resource").val(searchValue);
  }

  if (urlParams.has("cat")) {
    let resourceValue = urlParams.getAll("cat");
    resourceValue.forEach((e) => {
      $('.filter-form__checkbox[value="' + e + '"]').prop("checked", true);
    });
  }
  if (urlParams.has("search-resource") || urlParams.has("cat")) {
    searchParamsUpdate();
    filterForm.submit(resourcesFilterSubmit());
  }
});
